export class SparkArray<T> extends Array<T> {
  constructor(items?: T[]) {
    super();
    items && this.addItems(items);
  }

  addItems(items: T[]) {
    items.forEach((i) => this.push(i));
  }

  // built-in methods will use this as the constructor
  static get [Symbol.species]() {
    return Array;
  }
}
